import { z } from 'zod';
export const otSupervisoryValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        evaluation: z
            .object({
            onSiteVisit: z.string().min(1, 'required'),
            maintainsOpenCommunication: z.string().min(1, 'required'),
            arrivesAsScheduled: z.string().min(1, 'required'),
            followsPlanOfCare: z.string().min(1, 'required'),
            goalProgress: z.string().min(1, 'required'),
            demonstratesCompetency: z.string().min(1, 'required'),
            informsSupervisor: z.string().min(1, 'required'),
            compliesWithInfectionControl: z.string().min(1, 'required'),
            honorsClientRights: z.string().min(1, 'required'),
            changesMadeToPlanOfCare: z.string().min(1, 'required'),
            deficiencyIdentified: z.string().min(1, 'required'),
            correctiveAction: z.string().optional(),
            comments: z.string().optional(),
        })
            .superRefine((data, ctx) => {
            if (data.deficiencyIdentified === 'yes' && !data.correctiveAction?.trim()) {
                ctx.addIssue({
                    path: ['correctiveAction'],
                    code: z.ZodIssueCode.custom,
                    message: 'required',
                });
            }
        }),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
